import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  CssBaseline,
  Grid,
  IconButton,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import { StyledButton } from "../../../components/common/Button";
import CircleIcon from "@mui/icons-material/Circle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import educator from "../../../assets/educator.png";
import institute from "../../../assets/institute.png";
import academy from "../../../assets/academy.png";
import { Star } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { allHeadings } from "./Features";

const Plans = ({ active, setActive }) => {
  const [expanded, setExpanded] = useState([]);
  const [expand, setExpand] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [activePlan, setActivePlan] = useState("ANNUAL");
  const planButton = [
    {
      title: "MONTHLY",
    },
    {
      title: "ANNUAL",
    },
  ];

  const pricePlans = [
    {
      imgSrc: educator,
      title: "Free",
      subtitle: "Educator",
      buttonText: "LOGIN",
      buttonColor: `${theme.palette.primary.main}`,
      buttonbgColor: "#FFF",
      buttonBorder: `1px solid ${theme.palette.primary.main}`,
    },
    {
      imgSrc: institute,
      title: activePlan === "MONTHLY" ? "$25" : "$20",
      subtitle: "Academy",
      buttonText: "BUY NOW",
      buttonColor: "",
      buttonbgColor: `${theme.palette.primary.main}`,
      buttonBorder: "",
    },
    {
      imgSrc: academy,
      title: activePlan === "MONTHLY" ? "$75" : "$60",
      subtitle: "Institute",
      buttonText: "BUY NOW",
      buttonColor: "",
      buttonbgColor: `${theme.palette.primary.main}`,
      buttonBorder: "",
    },
  ];

  useEffect(() => {
    const initialExpanded = allHeadings.map((item) => item.headings[0].panel);
    setExpand(initialExpanded);
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpand((prevExpanded) => {
      if (isExpanded) {
        return prevExpanded.includes(panel)
          ? prevExpanded
          : [...prevExpanded, panel];
      } else {
        return prevExpanded.filter((p) => p !== panel);
      }
    });
  };

  const handleExpand = (index) => {
    setActive(index);
    setExpanded((prevState) => {
      const updatedExpanded = [...prevState];
      updatedExpanded[index] = !updatedExpanded[index];
      for (let i = 0; i < updatedExpanded.length; i++) {
        if (i !== index) {
          updatedExpanded[i] = false;
        }
      }
      return updatedExpanded;
    });
    setIsExpanded(true);
  };

  const handleCollapse = (index) => {
    setActive(index);
    setExpanded((prevState) => {
      const updatedExpanded = [...prevState];
      updatedExpanded[index] = false;
      return updatedExpanded;
    });
  };

  const handleClick = (item) => {
    setActive(item);
  };

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container>
        {isMobile ? (
          <Box>
            <Box sx={{ marginTop: "2.5rem" }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  fontSize: "1.375rem",
                  color: "#212121",
                  textAlign: "center",
                }}
              >
                Perfect plans & pricing for your needs
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: "2.5rem",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "4rem",
                  gap: "1.125rem",
                }}
              >
                {planButton.map((item, index) => (
                  <StyledButton
                    key={index}
                    variant="contained"
                    height="1.5rem"
                    width="5.75rem"
                    style={{
                      backgroundColor:
                        activePlan === item.title ? "#FFF" : "#EEF6FF",
                      color:
                        activePlan === item.title
                          ? theme.palette.primary.main
                          : "#212121",
                      border:
                        activePlan === item.title
                          ? `1px solid ${theme.palette.primary.main}`
                          : "none",
                      borderRadius: "1.022175rem",
                    }}
                    onClick={() => setActivePlan(item.title)}
                  >
                    <Typography sx={{ fontSize: "0.5rem" }}>
                      {item.title}
                    </Typography>
                    <IconButton sx={{ marginLeft: "0.875rem" }}>
                      <CircleIcon
                        style={{
                          height: "0.5rem",
                          width: "0.5rem",
                          color:
                            activePlan === item.title
                              ? theme.palette.primary.main
                              : "#FFF",
                        }}
                      />
                    </IconButton>
                  </StyledButton>
                ))}
              </Box>
              <Container>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.5rem",
                    letterSpacing: "0.0532384375rem",
                    color: "#0C9D46",
                    whiteSpace: "nowrap",
                  }}
                >
                  SAVE 20%
                </Typography>
              </Container>
            </Box>
          </Box>
        ) : (
          <Box>
            <Box sx={{ marginTop: "5rem" }}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  fontSize: "3rem",
                  color: "#212121",
                  textAlign: "center",
                }}
              >
                Perfect plans & pricing for your needs
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: "3.75rem",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flex: "1",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.25rem",
                    letterSpacing: "0.01rem",
                    color: "#212121",
                    whiteSpace: "nowrap",
                  }}
                >
                  Select Duration :
                </Typography>
                {planButton.map((item, index) => (
                  <StyledButton
                    key={index}
                    variant="contained"
                    height="3rem"
                    width="10rem"
                    style={{
                      backgroundColor:
                        activePlan === item.title ? "#FFF" : "#EEF6FF",
                      color:
                        activePlan === item.title
                          ? theme.palette.primary.main
                          : "#212121",
                      border:
                        activePlan === item.title
                          ? `1px solid ${theme.palette.primary.main}`
                          : "none",
                      boxShadow: "0px 8px 24px rgba(88, 101, 242, 0.15)",
                    }}
                    onClick={() => setActivePlan(item.title)}
                  >
                    {item.title}
                    <IconButton sx={{ marginLeft: "1.75rem" }}>
                      <CircleIcon
                        style={{
                          height: "1rem",
                          width: "1rem",
                          color:
                            activePlan === item.title
                              ? theme.palette.primary.main
                              : "#FFF",
                        }}
                      />
                    </IconButton>
                  </StyledButton>
                ))}
              </Box>
              <Container sx={{ display: "flex", flex: "1" }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.875rem",
                    letterSpacing: "0.078125rem",
                    color: "#0C9D46",
                    whiteSpace: "nowrap",
                  }}
                >
                  Save upto 20% with annual plans
                </Typography>
              </Container>
            </Box>
          </Box>
        )}

        <Box
          sx={{
            marginTop: ["2.5rem", "4.75rem"],
            display: "flex",
            gap: "1.5rem",
          }}
        >
          <Container
            sx={{
              display: { xs: "none", sm: "block" },
              borderRadius: "0.75rem",
              backgroundColor: "#EEF6FF",
              width: "22rem",
            }}
          >
            <Box sx={{ marginTop: "6.25rem" }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  fontSize: "2rem",
                  letterSpacing: "0.015625rem",
                  color: "#212121",
                }}
              >
                Pricing
              </Typography>
            </Box>
            <Box sx={{ marginTop: "0.5rem" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  fontSize: "1.25rem",
                  letterSpacing: "0.01rem",
                  color: "#212121",
                }}
              >
                Plans
              </Typography>
            </Box>
          </Container>
          <Grid container spacing={3}>
            {pricePlans.map((item, index) => (
              <Grid item xs={12} sm={4} key={index} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    borderRadius: ["1.25rem", "0.75rem"],
                    width: "100%",
                    ...(isMobile && {
                      boxShadow: "0px 8px 24px rgba(88, 101, 242, 0.15)",
                    }),
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: ["1.25rem", "0.75rem"],
                      border: ` 0.4px solid ${theme.palette.primary.main}`,
                      width: "100%",
                      position: "relative",
                      cursor: "pointer",
                      ...(isMobile && { height: "14.125rem" }),
                    }}
                    onClick={isMobile ? undefined : () => handleClick(index)}
                  >
                    {item.subtitle === "Academy" && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "-1rem",
                          left: "50%",
                          transform: "translateX(-50%)",
                          borderRadius: "1rem",
                          width: "10rem",
                          height: "2rem",
                          color: theme.palette.primary.main,
                          border: `1px solid ${theme.palette.primary.main}`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <Star
                            sx={{
                              height: "0.87875rem",
                              width: "0.920625rem",
                            }}
                          />
                        </Box>
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: 700,
                            fontSize: ["0.75rem", "1rem"],
                            letterSpacing: ["0.0079055rem", "0.01rem"],
                            marginLeft: ["0.530625rem", "0.25rem"],
                            whiteSpace: "nowrap",
                          }}
                        >
                          Most Popular
                        </Typography>
                      </Box>
                    )}

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: ["2.5rem", "2.113125rem"],
                      }}
                    >
                      {isMobile ? (
                        <img
                          src={item.imgSrc}
                          alt=""
                          style={{
                            height: "1.529375rem",
                            width: "1.25rem",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <img
                          src={item.imgSrc}
                          alt=""
                          style={{
                            height: "2.25rem",
                            width: "2.25rem",
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </Box>
                    <Box
                      sx={{
                        marginTop: ["1.283125rem", "2.6075rem"],
                      }}
                    >
                      {item.title === "Free" ? (
                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: 700,
                            fontSize: ["1.375rem", "2rem"],
                            letterSpacing: ["0.010681125rem", "0.015625rem"],
                            textAlign: "center",
                            color: "#212121",
                          }}
                        >
                          {item.title}
                        </Typography>
                      ) : (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Typography
                            variant="h4"
                            sx={{
                              fontWeight: 700,
                              fontSize: ["1.375rem", "2rem"],
                              letterSpacing: ["0.010681125rem", "0.015625rem"],
                              color: "#212121",
                              display: "flex",
                              alignItems: "baseline",
                            }}
                          >
                            <span>{item.title}</span>
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontSize: "0.75rem",
                                color: "#6A6A6A",
                                marginLeft: "0.5rem",
                              }}
                            >
                              /month
                            </Typography>
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "0.5rem",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 700,
                          fontSize: ["1rem", "1.25rem"],
                          letterSpacing: ["0.008056625rem", "0.01rem"],
                          color: `${theme.palette.primary.main}`,
                        }}
                      >
                        {item.subtitle}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: ["1.25rem", "2rem"],
                        marginBottom: ["2.5rem", "2.0625rem"],
                      }}
                    >
                      <div onClick={(e) => e.stopPropagation()}>
                        {isMobile ? (
                          <StyledButton
                            variant="contained"
                            height="1.5rem"
                            width="10.375rem"
                            style={{
                              backgroundColor: item.buttonbgColor,
                              color: item.buttonColor,
                              border: item.buttonBorder,
                              borderRadius: "1.022175rem",
                            }}
                          >
                            <Typography sx={{ fontSize: "0.5rem" }}>
                              {item.buttonText}
                            </Typography>
                          </StyledButton>
                        ) : (
                          <StyledButton
                            variant="contained"
                            height="3rem"
                            width="11.5rem"
                            style={{
                              backgroundColor: item.buttonbgColor,
                              color: item.buttonColor,
                              border: item.buttonBorder,
                              boxShadow:
                                "0px 8px 24px rgba(88, 101, 242, 0.15)",
                            }}
                          >
                            {item.buttonText}
                          </StyledButton>
                        )}
                      </div>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: { xs: "block", sm: "none" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "1.25rem",
                        marginBottom: "1.25rem",
                        color: `${theme.palette.primary.main}`,
                        gap: "0.5rem",
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontSize: "0.5rem",
                          fontWeight: 700,
                          letterSpacing: "0.0532384375rem",
                          ...(expanded[index] && { display: "none" }),
                        }}
                        onClick={() => handleExpand(index)}
                      >
                        VIEW ALL FEATURES
                      </Typography>
                      <ExpandMoreIcon
                        onClick={() => handleExpand(index)}
                        sx={{ ...(expanded[index] && { display: "none" }) }}
                      />
                      {expanded[index] && (
                        <Box>
                          {allHeadings.map((item, index) => (
                            <Box
                              key={index}
                              sx={{
                                marginTop: "2.5rem",
                                display: active === index ? "block" : "none",
                              }}
                            >
                              {item.headings.map((item, index) => (
                                <Accordion
                                  key={index}
                                  expanded={expand.includes(item.panel)}
                                  onChange={handleChange(item.panel)}
                                  sx={{
                                    borderBottom: `1px solid ${theme.palette.primary.main}`,
                                  }}
                                >
                                  <AccordionSummary
                                    expandIcon={
                                      <ExpandMoreIcon
                                        sx={{
                                          color: `${theme.palette.primary.main}`,
                                        }}
                                      />
                                    }
                                  >
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        color: `${theme.palette.primary.main}`,
                                        fontSize: "0.75rem",
                                        letterSpacing: "0.0079055rem",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {item.title}
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      {item.subheadings.map(
                                        (subheading, subIndex) => (
                                          <Box
                                            key={subIndex}
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flex: 1,
                                              }}
                                            >
                                              <Typography
                                                variant="h6"
                                                sx={{
                                                  fontSize: "0.75rem",
                                                  fontWeight: 700,
                                                  letterSpacing: "0.0079055rem",
                                                  color: "#212121",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {subheading.subtitle}
                                              </Typography>
                                            </Box>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flex: 3,
                                              }}
                                            >
                                              <Grid container spacing={2}>
                                                {subheading.gridData.map(
                                                  (item, index) => (
                                                    <Grid
                                                      item
                                                      xs={4}
                                                      key={index}
                                                    >
                                                      <Box
                                                        sx={{
                                                          height: "0.75rem",
                                                          width: "13.5rem",
                                                          marginBottom:
                                                            "0.75rem",
                                                          display:
                                                            index === 1
                                                              ? "block"
                                                              : "none",
                                                        }}
                                                      >
                                                        <Box
                                                          sx={{
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                            fontSize: "0.75rem",
                                                          }}
                                                        >
                                                          {item.title}
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                  )
                                                )}
                                              </Grid>
                                            </Box>
                                          </Box>
                                        )
                                      )}
                                    </Box>
                                  </AccordionDetails>
                                </Accordion>
                              ))}
                            </Box>
                          ))}
                          {isExpanded && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "1.25rem",
                                color: `${theme.palette.primary.main}`,
                                gap: "0.5rem",
                              }}
                              onClick={() => handleCollapse(index)}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  color: `${theme.palette.primary.main}`,
                                  fontSize: "0.5rem",
                                  fontWeight: 700,
                                  letterSpacing: "0.0532384375rem",
                                  textAlign: "center",
                                }}
                              >
                                COLLAPSE
                              </Typography>
                              <ExpandLessIcon />
                            </Box>
                          )}
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default Plans;
